import { createComponent } from '@carvana/merch-components';

export const Description = createComponent('p', {
  className: 't-body-sm text-text-default'
});

export const Heading = createComponent('h3', {
  className: 't-heading-lg text-text-strong'
});

export const Wrapper = createComponent('div', {
  className: 'flex flex-col gap-md px-2xl py-xl sm:pl-2xl md:pl-0'
});
